/**
 * GameDebugPanel — React overlay showing live Phaser game state.
 * Active when ?debug=true is in URL or localStorage key 'henry_debug' is set.
 * 
 * Usage: Add ?debug=true to URL, or run in console: localStorage.setItem('henry_debug', '1')
 */
import { useEffect, useRef, useState } from 'react';

interface DebugState {
  scene: string;
  player: { x: number; y: number; hp: number; maxHp: number } | null;
  wave: number;
  enemies: number;
  timer: string;
  upgradeOpen: boolean;
  coins: number;
  kills: number;
}

const EMPTY: DebugState = {
  scene: 'unknown',
  player: null,
  wave: 0,
  enemies: 0,
  timer: '0:00',
  upgradeOpen: false,
  coins: 0,
  kills: 0,
};

export function GameDebugPanel() {
  const [visible, setVisible] = useState(false);
  const [state, setState] = useState<DebugState>(EMPTY);

  useEffect(() => {
    const check = () => {
      const has = new URLSearchParams(window.location.search).get('debug') === 'true'
        || localStorage.getItem('henry_debug') === '1';
      setVisible(has);
    };
    check();

  // Expose debug state setter for Phaser to call
  (window as any).__henrySetDebug = (s: Partial<DebugState>) => {
    setState(prev => ({ ...prev, ...s }));
  };

  const handler = () => check();
  window.addEventListener('popstate', handler);
  return () => window.removeEventListener('popstate', handler);
}, []);

if (!visible) return null;

return (
  <div style={{
    position: 'fixed',
    bottom: 10,
    left: 10,
    zIndex: 9999,
    background: 'rgba(0,0,0,0.85)',
    color: '#00ff00',
    fontFamily: 'monospace',
    fontSize: 11,
    padding: '8px 12px',
    borderRadius: 8,
    border: '1px solid #00ff00',
    minWidth: 180,
    pointerEvents: 'none',
  }}>
    <div style={{ color: '#ffff00', marginBottom: 4 }}>🔧 HENRY DEBUG</div>
    <div>Scene: {state.scene}</div>
    <div>Wave: {state.wave}</div>
    <div>Timer: {state.timer}</div>
    <div>HP: {state.player ? `${state.player.hp}/${state.player.maxHp}` : '-'}</div>
    <div>Pos: {state.player ? `${Math.round(state.player.x)}, ${Math.round(state.player.y)}` : '-'}</div>
    <div>Enemies: {state.enemies}</div>
    <div>Coins: {state.coins}</div>
    <div>Kills: {state.kills}</div>
    <div>Upgrade: {state.upgradeOpen ? '✅' : '❌'}</div>
    <div style={{ marginTop: 4, color: '#888' }}>Press F12 for console</div>
  </div>
);
}